// chatConfigStorage.js

const CHAT_CONFIG_KEY = "ACTIVE_CHAT_CONFIG";

/**
 * Get active chat config.
 * Returns the stored config or null.
 */
export function getChatConfig() {
  try {
    const stored = localStorage.getItem(CHAT_CONFIG_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (err) {
    console.warn("[CHAT_CONFIG_PARSE_ERROR]", err);
    return null;
  }
}

/**
 * Store EXACTLY one chat config (always overwrite).
 * @param {object} config
 */
export function setChatConfig(config) {
  if (!config || typeof config !== "object") {
    console.warn("[CHAT_CONFIG_INVALID_SET]", config);
    return;
  }

  const safeConfig = {
    journey: config.journey, // "VOICE" | "TEXT"
    language: config.language, // "en", "hi", etc.
    journeyLocked: !!config.journeyLocked,
    languageLocked: !!config.languageLocked,
    updatedAt: Date.now(),
  };

  localStorage.setItem(CHAT_CONFIG_KEY, JSON.stringify(safeConfig));
}

/**
 * Update ONLY provided fields in existing chat config.
 * Does NOT overwrite unspecified fields.
 * @param {object} partialConfig
 */
export function updateChatConfig(partialConfig) {
  if (!partialConfig || typeof partialConfig !== "object") {
    console.warn("[CHAT_CONFIG_INVALID_UPDATE]", partialConfig);
    return;
  }

  const existing = getChatConfig();

  if (!existing) {
    console.warn("[CHAT_CONFIG_UPDATE_NO_EXISTING]", partialConfig);
    return;
  }

  const updatedConfig = {
    ...existing,
    ...partialConfig,
    updatedAt: Date.now(),
  };

  localStorage.setItem(CHAT_CONFIG_KEY, JSON.stringify(updatedConfig));
}

/**
 * Clear active chat config (new chat / logout).
 */
export function clearChatConfig() {
  localStorage.removeItem(CHAT_CONFIG_KEY);
}
